import sizes from '../../theme/foundations/sizes'
import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'
import {textDecoration} from '@chakra-ui/react'

export const BlogPageStyle = {
    width: '100',
    maxWidth: pxToRem(1140),
    margin: '0 auto',
    px: pxToRem(15),
    '.blog-container': {
        maxWidth: pxToRem(1140),
        margin: '0 auto',
        padding: `0 ${pxToRem(15)}`,
        '.blog-name': {
            margin: `${pxToRem(25)} 0`
        },
        h2: {
            fontWeight: 700
        }
    },

    '.blog-banner': {
        a: {
            textDecoration: 'none',
            _hover: {
                textDecoration: 'none',
                span: {
                    color: 'cav_hover_brightred'
                }
            }
        }
    },

    '.description': {
        display: '-webkit-box',
        overflow: 'hidden',
        '-webkit-line-clamp': 4,
        '-webkit-box-orient': 'vertical',
        lineHeight: pxToRem(18),
        maxHeight: pxToRem(72),
        textAlign: 'justify',
        textJustify: 'inter-word'
    },

    '.blog-content-asset': {
        p: {
            fontSize: pxToRem(16),
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            letterSpacing: pxToRem(1.28),
            margin: `${pxToRem(16)} 0`,
            color: 'cav_light_black',
            fontFamily: fonts.primary
        },
        h1: {
            fontSize: pxToRem(21),
            marginBottom: pxToRem(14),
            fontWeight: 400,
            fontFamily: fonts.primary,
            [`@media (max-width: ${sizes.container.md})`]: {
                fontSize: pxToRem(24),
                margin: `${pxToRem(10)} 0`
            }
        },
        h2: {
            textTransform: 'uppercase',
            fontSize: pxToRem(16),
            color: 'cav_light_black',
            fontFamily: fonts.primary,
            [`@media (max-width: ${sizes.container.md})`]: {
                fontSize: pxToRem(24),
                lineHeight: pxToRem(30)
            }
        },
        h3: {
            fontSize: pxToRem(30),
            margin: '1.5rem 0',
            textAlign: 'center',
            fontFamily: fonts.primary,
            letterSpacing: pxToRem(1),
            fontWeight: 700
        },

        a: {
            overflow: 'hidden',
            background: 'transparent',
            color: 'cav_red',
            outline: 'medium none',
            fontSize: pxToRem(16),
            lineHeight: 'auto',
            latterSpacing: pxToRem(1),
            textDecoration: 'none',
            margin: 'auto',
            _hover: {
                h2: {
                    color: 'red'
                }
            }
        },
        'a:hover': {
            textDecoration: 'none'
        },
        'ul li': {
            listStyle: 'square outside none',
            lineHeight: pxToRem(24)
        },
        'ol li': {
            listStyle: 'decimal outside none',
            lineHeight: pxToRem(24)
        },
        hr: {
            boxSizing: 'content-box',
            height: 0,
            borderWidth: pxToRem(1),
            opacity: '.5'
        }
    },
    '.articles-pagination': {
        mb: {base: pxToRem(15), lg: pxToRem(25)},
        gap: {base: 8, lg: 4},
        flexDirection: {base: 'column', md: 'row'},
        justifyContent: 'space-between',
        div: {
            margin: '0 !important'
        },
        select: {
            border: '1px solid black',
            borderRadius: pxToRem(3),
            textTransform: 'uppercase',
            fontSize: pxToRem(14),
            fontWeight: 'semibold'
        },
        '.per-page-container': {
            display: {base: 'none', md: 'flex'},
            justifyContent: 'end',
            '>div': {
                maxWidth: pxToRem(170)
            }
        },
        '.pagination-detail': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: {base: 'start', lg: 'center'},
            border: {base: '0', md: '1px solid black'},
            borderBottom: '1px solid black',
            paddingX: {base: '0', lg: pxToRem(16)},
            paddingY: {base: pxToRem(10), lg: '0'},
            width: {base: '100%', lg: '28.5%'},
            '.page-list': {
                display: 'flex',
                gap: 2,
                padding: '0',
                margin: '0',
                mx: 'auto',
                li: {
                    color: 'cav_dark_red',
                    textDecoration: 'underline',
                    fontWeight: 'bold',
                    fontSize: {base: pxToRem(16), lg: pxToRem(14)},
                    paddingX: pxToRem(10)
                },
                'li.active': {
                    color: '#000',
                    textDecoration: 'none'
                },
                'li a': {
                    textDecoration: 'inherit'
                },
                'li:first-child': {
                    textDecoration: 'none'
                },
                'li:last-child': {
                    textDecoration: 'none'
                }
            }
        },
        '> div:nth-child(1)': {
            width: {base: '100%', lg: '28%'}
        },
        '> div:nth-child(2)': {
            width: {base: '100%', lg: '42%'}
        }
    }
}
